<template>
	<div
		class="align-self-center text-gotham-bold"
		style="font-size: 24px;color: #5f51a1;"
		:style="countStyle"
	>
		<template v-if="!onlySecond">
			<span v-if="days">{{ formatDays(days) }} </span>
			<span>{{ formatNumber(hours) }}:</span>
			<span>{{ formatNumber(minutes) }}:</span>
		</template>
		<span>{{ formatNumber(seconds) }}</span>
	</div>
</template>

<script>
export default {
	props: {
		num: {
			type: Number,
			required: true,
		},
		onlySecond: Boolean,
    noZeroPrefix: Boolean,
		countStyle: String,
	},
	data() {
		return {
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			intervalId: null,
		};
	},
	mounted() {
		this.updateTime();
		this.intervalId = setInterval(this.updateTime, 1000);
	},
	methods: {
		updateTime() {
			let number = this.num;

			// Calculate days, hours, minutes, and seconds
			this.days = Math.floor(number / (60 * 60 * 24));
			let remainingSeconds = number % (60 * 60 * 24);
			this.hours = Math.floor(remainingSeconds / (60 * 60));
			remainingSeconds %= 60 * 60;
			this.minutes = Math.floor(remainingSeconds / 60);
			this.seconds = remainingSeconds % 60;

			if (number <= 0) {
				this.$emit('onTimerEnd');
				return;
			}

			// Decrement the number of seconds
			number -= 1;

			this.$emit('onTick', number);
		},
		formatNumber(num) {
			return num < 10 && !this.noZeroPrefix ? `0${num}` : num;
		},
		formatDays(days) {
			return `${days} Day${days > 1 ? 's' : ''}`;
		},
	},
	beforeDestroy() {
		clearInterval(this.intervalId);
	},
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
